<template>
  <div>
    <div class="tabs-nav-wrap">
      <ul class="tabs-nav">
        <li :class="curItem === item.name ? 'active' : ''" v-for="(item, index) in content" :key="item.alt" @click="selectItem(item.name, index)">
          <div>
            <img v-lazy="require(`@/assets/image/${item.icon}.png`)" :alt="item.alt">
          </div>
          <p>{{item.name}}</p>
        </li>
      </ul>
    </div>
    <div class="tabs-content">
      <video ref="video" muted autoplay loop style="width:100%" v-if="!windowType"></video>
      <img ref="vgif" alt="tag-gif" v-else>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tab-first',
  props: {
    type: Number,
    content: Array,
    windowType: Boolean
  },
  data () {
    return {
      curItem: ''
    }
  },
  mounted () {
    this.curItem = this.content[0].name
    if (!this.windowType) {
      this.$refs.video.src = this.setUrl('video', this.content[0].video)
    } else {
      this.$refs.vgif.src = this.setUrl('gif', this.content[0].gif)
    }
  },
  watch: {
    type (newV, OldV) {
      this.curItem = this.content[0].name
      if (!this.windowType) {
        this.$refs.video.src = this.setUrl('video', this.content[0].video)
      } else {
        this.$refs.vgif.src = this.setUrl('gif', this.content[0].gif)
      }
    }
  },
  methods: {
    setUrl (type, name) {
      let res = ''
      const fileType = type === 'video' ? 'mp4' : 'gif'
      res = require(`@/assets/image/${name}.${fileType}`)
      return res
    },
    selectItem (name, index) {
      // 当前项避免点击加载
      if (name === this.curItem) {
        return
      }
      this.curItem = name
      if (!this.windowType) {
        this.$refs.video.src = this.setUrl('video', this.content[index].video)
      } else {
        this.$refs.vgif.src = this.setUrl('gif', this.content[index].gif)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.tabs-nav {
  display: flex;
  justify-content: center;
  li {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    margin: 0 2rem;
    text-align: center;
    color: #696969;
    font-size: 1rem;
    cursor: pointer;
    & > div {
      display: flex;
      align-items: center;
    }
    p {
      padding-top: 10px;
    }
    img {
      width: 100%;
      max-height: 56px;
    }
  }
}
.tabs-nav li.active,
.tabs-nav li:hover {
  color: #4a9feb;
}
.tabs-content {
  width: 100%;
  margin-top: 3rem;
  border-radius: 1rem;
  overflow: hidden;
  img {
    width: 100%;
  }
}
@media (max-width: 1200px) {
  .tabs-nav li {
    margin: 0 1.5rem;
  }
}
@media (max-width: 768px) {
  .tabs-nav li {
    margin: 0 1rem;
  }
  .tabs-nav-wrap {
    overflow-y: hidden;
    overflow-x: auto;
    padding: 0;
  }
  .tabs-nav li.active::after,
  .tabs-nav li:hover::after {
    width: 100%;
  }
}
@media (max-width: 576px) {
  .tabs-nav li {
    margin: 0 0.5rem;
    font-size: 12px;
  }
}
/*滚动条样式*/
.tabs-nav-wrap::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 4px;
}
.tabs-nav-wrap::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
.tabs-nav-wrap::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
</style>
